import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { push } from "connected-react-router";
import { useTranslation } from "react-i18next";
import { Actions as AuthActions } from "../../../store/ducks/auth";
import Dygraph from "dygraphs";
import moment from "moment";
import "moment/locale/pt-br";
import {
  Container,
  Avatar,
  Snackbar,
  Box,
  Button,
  Grid,
  Tooltip,
  Typography,
  Link,
  Badge,
  Card,
  CardContent,
  CardActions,
  CardMedia,
  Slider,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import AvatarGroup from "@material-ui/lab/AvatarGroup";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import googleLogo from "../../../resources/googleLogo.svg";
import CassieFerramenta from "../../../resources/CASSIE_Ferramenta.png";
import CassiePesquisa from "../../../resources/CASSIE_Pesquisa.jpg";
import CassieProjeto from "../../../resources/CASSIE_Projeto.png";
import TimeLineEN from "../../../resources/TimeLine_EN.png";
import TimeLinePT from "../../../resources/TimeLine_PT.png";
import geeLogo from "../../../resources/gee_icon.png";
import googleLogoDisabled from "../../../resources/googleLogoDisabled.svg";
import Slide from "@material-ui/core/Slide";
import HomePageLayout from "../../components/homepage/HomePageLayout";
import { useLocalStorage } from "../../../common/utils";
import { Bar, Chart } from "react-chartjs-2";

// useStyles is a hook for Material-UI's styling.
const useStyles = makeStyles((theme) => ({
  backdrop: {
    height: "100vh",
    width: "100vw",
    position: "fixed",
    zIndex: "-1",
    top: 0,
    left: 0,
    backgroundColor: theme.palette.primary.light,
  },
  heading: {
    backgroundColor: theme.palette.primary.main,
    background: "url(/bg.jpg)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
    minHeight: "75vh",
  },
  bay: {
    padding: "60px 0px",
    background: "url(/bay.jpg)",
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  risc: {
    padding: "60px 0px",
    background: "url(/port.jpg)",
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  headingContainer: {
    paddingBottom: "10vh",
    paddingTop: "15vh",
  },
  content: {
    padding: "60px 0px",
  },
  fullW: {
    with: "100%",
  },
  flex: {
    display: "flex",
  },
  logo: {
    fontSize: 120,
    color: "white",
    margin: "0px 0px 20px 0px",
  },
  title: {
    fontWeight: "600",
    marginBottom: theme.spacing(5),
  },
  subtitle: {
    fontSize: "1.5rem",
  },
  wrapper: {
    display: "flex",
    alignItems: "center",
    flexFlow: "column",
    backgroundColor: theme.palette.primary[200],
    padding: "40px 48px",
  },
  i18nSwitchers: {
    textAlign: "right",
    backgroundColor: "white",
  },
  i18nSwitch: {
    padding: "5px 10px",
    margin: "0 10px",
  },
  flag: {
    marginRight: "5px",
    height: "25px",
    width: "25px",
  },
  description: {
    margin: "30px 0px 40px 0px",
    color: "rgba(0, 0, 0, 0.85)",
  },
  google: {
    margin: "-4px 20px -4px -15px",
  },
  intro_gif: {
    maxWidth: "100%",
  },
  spaced_text: {
    marginBottom: theme.spacing(4),
  },
  bay_text: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(5),
    borderRadius: theme.spacing(1),
  },
  spaced_btn: {
    marginRight: "16px",
  },
  large: {
    width: theme.spacing(12),
    height: theme.spacing(12),
    border: `2px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  small: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    border: `2px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  sponsor_img: {
    height: theme.spacing(6),
    maxWidth: "100%",
    marginBottom: theme.spacing(2),
  },
  sponsor_img_sqr: {
    height: theme.spacing(13),
    maxWidth: "100%",
    marginBottom: theme.spacing(2),
  },
  sponsor_img_partner: {
    height: theme.spacing(10),
    maxWidth: "100%",
    marginBottom: theme.spacing(2),
  },
  avatar_link: {
    border: "none",
  },
  snack: {
    maxWidth: "75%",
  },
  cpnq_logo: {
    maxWidth: "150px",
  },
}));

// Create a custom Typography component.
const WhiteTextTypography = withStyles({
  root: {
    color: "#FFFFFF",
  },
})(Typography);

// Create a custom Avatar component.
const SmallAvatar = withStyles((theme) => ({
  root: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    backgroundColor: theme.palette.background.paper,
    border: `2px solid ${theme.palette.divider}`,
    borderRadius: ".75rem",
  },
}))(Avatar);

// Create a transition component.
function TransitionLeft(props) {
  return <Slide {...props} direction="left" />;
}

// main function
function HomePage() {
  // check if the authentication is busy
  const busy = useSelector((state) => state.auth.authenticating);

  const dispatch = useDispatch();
  // use i18n
  const [t] = useTranslation();
  const chartLang = t("forms.transectEvolution.chartLanguage");
  const charLanguage = chartLang.toLowerCase().includes("portugu");
  moment.locale(charLanguage ? "pt-BR" : "en");
  // use custom styles
  const classes = useStyles();

  const groupsData = {
    ufsc: {
      name: "UFSC",
      img: "ufsc.png",
      link: "https://ufsc.br/",
    },
    univali: {
      name: "UNIVALI",
      img: "univali.png",
      link: "https://univali.br",
    },
    ufrgs: {
      name: "UFRGS",
      img: "logo_ufrgs.jpeg",
      link: "https://ufrgs.br/",
    },
    ufma: {
      name: "UFMA",
      img: "ufma.png",
      link: "https://www.ufma.br/",
    },
    griffith: {
      name: "Griffith University",
      img: "GRIF.png",
      link: "https://www.griffith.edu.au/",
    },
    atlantic: {
      name: "ATLANTIC",
      img: "atlantic.png",
      link: "https://colabatlantic.com/",
    },
    waikato: {
      name: "University of Waikato",
      img: "waikato_university.jpg",
      link: "https://www.waikato.ac.nz/",
    },
    sydney: {
      name: "University of Sydney",
      img: "usyd.png",
      link: "https://www.sydney.edu.au/",
    },
    palmsoft: {
      name: "PalmSoft",
      img: "palmsoft.png",
      link: "https://palmsoft.com.br/",
    },
    ulisboa: {
      name: "Universidade de Lisboa",
      img: "lisboa.png",
      link: "https://www.ulisboa.pt/",
    },
    ima: {
      name: "IMA",
      img: "IMA.png",
      link: "",
    },
    appix: {
      name: "Appix",
      img: "appix_logo.png",
      link: "https://appix.com.br/",
    },
    boticario: {
      name: "Boticário",
      img: "boticario.png",
      link: "",
    },
    loc: {
      name: "LOC UFSC",
      img: "loc.png",
      link: "https://loc.ufsc.br/",
    },
    lia: {
      name: "LIA Univali",
      img: "lia_sm.png",
      link: "http://ialab.com.br/",
    },
    cnpq: {
      name: "CNPQ",
      img: "cnpq.png",
      link: "http://cnpq.br/",
    },
  };

  const teamPhotos = {
    anita: "https://cassiecore.paginas.ufsc.br/files/2023/08/uii.jpg",
    klein: "https://cassiecore.paginas.ufsc.br/files/2023/08/ghjj-284x300.jpg",
    dennis: "https://cassiecore.paginas.ufsc.br/files/2023/10/Dennis-150x150.jpg",
    luispedro:
      "https://servicosweb.cnpq.br/wspessoa/servletrecuperafoto?tipo=1&id=K8030070U9",
    anapaula: "https://profiles.sydney.edu.au/ana.dasilva/thumbnail",
    elirio:
      "https://cassiecore.paginas.ufsc.br/files/2023/10/Captura-de-tela-2025-12-11-130407-150x150.png",
    guilherme: "https://cassiecore.paginas.ufsc.br/files/2023/08/l%C3%A7.jpg",
    joao: "https://cassiecore.paginas.ufsc.br/files/2023/08/JHGFD-150x150.jpg",
    ligia:
      "https://cassiecore.paginas.ufsc.br/files/2023/10/FB_IMG_1701450711333-150x150.jpg",
    paula:
      "https://cassiecore.paginas.ufsc.br/files/2023/10/1631274126465-150x150.jpg",
    pedrosouza:
      "https://cassiecore.paginas.ufsc.br/files/2023/10/FotoZap-150x150.png",
    wagner: "https://cassiecore.paginas.ufsc.br/files/2023/08/wagner-150x150.jpg",
    andrigo:
      "https://cassiecore.paginas.ufsc.br/files/2023/10/andrigo-150x150.jpg",
    anderson:
      "https://cassiecore.paginas.ufsc.br/files/2023/10/WhatsApp-Image-2025-12-10-at-10.27.46-150x150.jpeg",
    bruna:
      "https://cassiecore.paginas.ufsc.br/files/2023/10/Bruna-Barreto-150x150.jpg",
    cicero:
      "https://cassiecore.paginas.ufsc.br/files/2023/10/Imagem-do-WhatsApp-de-2023-12-01-%C3%A0s-13.57.47_f46c15ca-150x150.jpg",
    eduardo:
      "https://cassiecore.paginas.ufsc.br/files/2023/10/WhatsApp-Image-2025-12-10-at-10.01.45-150x150.jpeg",
    henrique:
      "https://cassiecore.paginas.ufsc.br/files/2023/10/WhatsApp-Image-2024-03-08-at-10.34.04-150x150.jpeg",
    lais: "https://cassiecore.paginas.ufsc.br/files/2023/08/llll-296x300.jpg",
    larissa: "https://cassiecore.paginas.ufsc.br/files/2023/08/ll-280x300.jpg",
    luisafoppa:
      "https://cassiecore.paginas.ufsc.br/files/2023/10/WhatsApp-Image-2025-12-11-at-10.43.56-150x150.jpeg",
    luizafiorini: "https://cassiecore.paginas.ufsc.br/files/2023/08/l-297x300.png",
    mario: "https://cassiecore.paginas.ufsc.br/files/2023/10/mario-150x150.png",
  };

  const teamBios = {
    anita:
      "Professora titular na UNIVALI; formação em Ciências e Processamento de Dados, mestrado em Ciência da Computação e doutorado em Engenharia de Produção. Atua com IA aplicada, Data Science e Big Data.",
    klein:
      "Oceanólogo, mestre em Geociências e doutor em Ciências do Mar (Geologia Marinha). Professor associado na UFSC; atua em evolução/morfodinâmica costeira, geoacústica/geofísica rasa e riscos costeiros/oceânicos.",
    dennis:
      "Cientista da Computação (UFSC) e mestre em Ciência da Computação. Sócio-diretor na PalmSoft e na empresa de IA Deepen; professor na UNIVALI (Design de Jogos, CC e Ciência de Dados).",
    luispedro:
      "Oceanógrafo (Univ. do Algarve), mestre em Geomática e doutor em Ciências do Mar (University of Plymouth). Professor auxiliar na Universidade de Lisboa; foi professor visitante na FURG.",
    anapaula:
      "Ana é doutora em Oceanografia Costeira pela Griffith University (Austrália), com pesquisa sobre bypass sedimentar em Fingal Head (NSW). Possui mestrado e graduação em Oceanografia pela UFSC. Atuou como pós-doutoranda na Université du Québec à Rimouski (Canadá, 2022–2023), em projeto sobre erosão costeira no Ártico Canadense.",
    elirio:
      "Geólogo e doutor em Geociências (UFRGS). Professor titular no IG-UFRGS (sedimentologia, geologia marinha/costeira e processos costeiros); atua com publicações, software/produtos tecnológicos e orientação acadêmica; editor convidado de periódicos.",
    guilherme:
      "Oceanógrafo (UNIVALI), mestre e doutor pela UFRGS. Research Fellow no Centro de Pesquisa Costeira e Marinha da Griffith University (Austrália).",
    joao:
      "Docente do DEOLI/UFMA e colaborador de pós-graduação; lidera a CCMar/UFMA e a gestão do NPE Ciências do Mar II. Formação em Oceanografia (UERJ) e Engenharia Civil (UNIVALI), com mestrado e doutorado em Engenharia Oceânica (COPPE/UFRJ).",
    ligia:
      "Mestra em Oceanografia (UFSC, 2023) e graduada em Oceanografia (UFPR, 2018). Bolsista do CoastSnap Brasil e vinculada ao LOC/UFSC; atua em processos costeiros.",
    paula:
      "Oceanógrafa (UNIVALI) e mestre em Geografia (UFSC). Doutora em Engenharia Costeira (Univ. de Cantabria) e pesquisadora no IHCantabria (Espanha), com foco em monitoramento/análise de morfodinâmica costeira (medições in-situ, sensoriamento remoto e modelagem numérica).",
    pedrosouza:
      "Graduado em Oceanologia (FURG) com mestrado e doutorado em Oceanografia Física/Química/Geológica (FURG). Docente da Coordenadoria Especial de Oceanografia da UFSC.",
    wagner:
      "Oceanógrafo (UFSC), mestre em Engenharia Costeira e Portuária (Univ. de Cantabria) e doutorando na Universidade de Waikato (Nova Zelândia).",
    andrigo:
      "Graduado em Ciência da Computação (UNIVALI), atuou como pesquisador em projetos e recebeu prêmios por mérito acadêmico (UNIVALI) e destaque estudantil da SBC.",
    anderson:
      "Técnico em Informática para Internet (SENAI) e cursou Ciência da Computação na UNISUL. Atua como desenvolvedor de software na PalmSoft Tecnologia.",
    bruna:
      "Graduanda em Oceanografia (UFSC) e bolsista no LOC-UFSC; pesquisa processos erosivos costeiros, engorda de praias, dinâmica sedimentar e mudanças na linha de costa.",
    cicero:
      "Engenheiro de Pesca (UNEB) e mestre em Geociências (UFPE). Doutorando em Geociências (UFRGS), estudando fenômenos e processos costeiros.",
    eduardo:
      "Bacharel em Design de Jogos e Entretenimento Digital (UNIVALI, 2022). Atua como desenvolvedor de software na Palmsoft.",
    henrique:
      "Graduado em Oceanografia (UFSC). Fez iniciação científica em gestão costeira e atuou como Cientista de Dados por 2 anos.",
    lais:
      "Engenheira Civil Costeira e Portuária (FURG), mestre em Geociências (UFRGS) e estudante de PhD no IHCantabria (Espanha).",
    larissa: "Oceanóloga (FURG) e mestranda em Oceanografia Costeira (UFSC).",
    luisafoppa:
      "Bacharel em Design de Games (UNIVALI, 2025). Atua como desenvolvedora de software na PalmSoft Tecnologia.",
    luizafiorini:
      "Engenheira Civil Costeira e Portuária (FURG) e mestranda em Geociências (UFRGS).",
    mario:
      "Oceanógrafo (IO-USP), mestre em Oceanografia Geológica (IO-USP) e doutorando em Geociências (UFRGS).",
  };

  const authorsData = {
    anita: {
      name: "Anita Maria da Rocha Fernandes",
      img: teamPhotos.anita,
      bio: t("home.bios.anita"),
      link: "https://lattes.cnpq.br/8716094042714766",
      group: groupsData.univali,
      role: t("home.members.roles.researcher"),
    },
    klein: {
      name: "Antonio Henrique da Fontoura Klein",
      img: teamPhotos.klein,
      bio: t("home.bios.klein"),
      link: "https://lattes.cnpq.br/2354029280846247",
      group: groupsData.ufsc,
      role: t("home.members.roles.coord_geral"),
    },
    dennis: {
      name: "Dennis Kerr Coelho",
      img: teamPhotos.dennis,
      bio: t("home.bios.dennis"),
      link: "https://www.linkedin.com/in/dennis-kerr-coelho-902a184/",
      group: groupsData.palmsoft,
      role: t("home.members.roles.desenvolvimento"),
    },
    luispedro: {
      name: "Luis Pedro Melo de Almeida",
      img: teamPhotos.luispedro,
      bio: t("home.bios.luispedro"),
      link: "https://lattes.cnpq.br/4892957787322492",
      group: groupsData.ulisboa,
      role: t("home.members.roles.researcher"),
    },

    anapaula: {
      name: "Ana Paula da Silva",
      img: teamPhotos.anapaula,
      bio: t("home.bios.anapaula"),
      link: "https://profiles.sydney.edu.au/ana.dasilva/",
      group: groupsData.sydney,
      role: t("home.members.roles.validacao"),
    },
    elirio: {
      name: "Elírio Toldo Júnior",
      img: teamPhotos.elirio,
      bio: t("home.bios.elirio"),
      link: "https://lattes.cnpq.br/6571341124735078",
      group: groupsData.ufrgs,
      role: t("home.members.roles.validacao"),
    },
    guilherme: {
      name: "Guilherme Vieira da Silva",
      img: teamPhotos.guilherme,
      bio: t("home.bios.guilherme"),
      link: "https://experts.griffith.edu.au/8199-guilherme-vieira-da-silva",
      group: groupsData.griffith,
      role: t("home.members.roles.validacao"),
    },
    joao: {
      name: "João Luiz Baptista de Carvalho",
      img: teamPhotos.joao,
      bio: t("home.bios.joao"),
      link: "https://lattes.cnpq.br/9082654844180588",
      group: groupsData.ufma,
      role: t("home.members.roles.validacao"),
    },
    ligia: {
      name: "Ligia de Freitas Tebechrani",
      img: teamPhotos.ligia,
      bio: t("home.bios.ligia"),
      link: "https://lattes.cnpq.br/1412232433715109",
      group: groupsData.ufsc,
      role: t("home.members.roles.validacao"),
    },
    paula: {
      name: "Paula Gomes da Silva",
      img: teamPhotos.paula,
      bio: t("home.bios.paula"),
      link: "https://lattes.cnpq.br/5639351119676688",
      group: groupsData.ufsc,
      role: t("home.members.roles.validacao"),
    },
    pedrosouza: {
      name: "Pedro de Souza Pereira",
      img: teamPhotos.pedrosouza,
      bio: t("home.bios.pedrosouza"),
      link: "https://lattes.cnpq.br/1937720114661455",
      group: groupsData.ufsc,
      role: t("home.members.roles.validacao"),
    },
    wagner: {
      name: "Wagner Costa",
      img: teamPhotos.wagner,
      bio: t("home.bios.wagner"),
      link: "http://lattes.cnpq.br/0302579217086183",
      group: groupsData.waikato,
      role: t("home.members.roles.validacao"),
    },

    andrigo: {
      name: "Andrigo Borba dos Santos",
      img: teamPhotos.andrigo,
      bio: t("home.bios.andrigo"),
      link: "https://lattes.cnpq.br/7210627337069209",
      group: groupsData.univali,
      role: t("home.members.roles.bolsista"),
    },
    anderson: {
      name: "Anderson Rodrigues",
      img: teamPhotos.anderson,
      bio: t("home.bios.anderson"),
      link: "https://www.linkedin.com/in/andersonnrodrigues/",
      group: groupsData.palmsoft,
      role: t("home.members.roles.bolsista"),
    },
    bruna: {
      name: "Bruna Muniz Lucas Barreto",
      img: teamPhotos.bruna,
      bio: t("home.bios.bruna"),
      link: "https://lattes.cnpq.br/3632363681996876",
      group: groupsData.ufsc,
      role: t("home.members.roles.bolsista"),
    },
    cicero: {
      name: "Cícero Vicente Ferreira Junior",
      img: teamPhotos.cicero,
      bio: t("home.bios.cicero"),
      link: "https://lattes.cnpq.br/8382540018164983",
      group: groupsData.ufrgs,
      role: t("home.members.roles.bolsista"),
    },
    eduardo: {
      name: "Eduardo Brugnago",
      img: teamPhotos.eduardo,
      bio: t("home.bios.eduardo"),
      link: "https://www.linkedin.com/in/eduardobrugnago/",
      group: groupsData.palmsoft,
      role: t("home.members.roles.bolsista"),
    },
    henrique: {
      name: "Henrique Faria Cordeiro",
      img: teamPhotos.henrique,
      bio: t("home.bios.henrique"),
      link: "https://lattes.cnpq.br/8644712925156789",
      group: groupsData.ufsc,
      role: t("home.members.roles.bolsista"),
    },
    lais: {
      name: "Laís Pool da Silva Freitas",
      img: teamPhotos.lais,
      bio: t("home.bios.lais"),
      link: "https://lattes.cnpq.br/5847904662794834",
      group: groupsData.ufrgs,
      role: t("home.members.roles.bolsista"),
    },
    larissa: {
      name: "Larissa Rayanny dos Santos Sousa",
      img: teamPhotos.larissa,
      bio: t("home.bios.larissa"),
      link: "https://lattes.cnpq.br/2482430536344059",
      group: groupsData.ufsc,
      role: t("home.members.roles.bolsista"),
    },
    luisafoppa: {
      name: "Luísa Rodrigues Foppa",
      img: teamPhotos.luisafoppa,
      bio: t("home.bios.luisafoppa"),
      link: "https://www.linkedin.com/in/luisa-rodrigues-foppa/",
      group: groupsData.palmsoft,
      role: t("home.members.roles.bolsista"),
    },
    luizafiorini: {
      name: "Luíza Fiorini",
      img: teamPhotos.luizafiorini,
      bio: t("home.bios.luizafiorini"),
      link: "https://lattes.cnpq.br/0471886480299370",
      group: groupsData.ufsc,
      role: t("home.members.roles.bolsista"),
    },
    mario: {
      name: "Mario Luiz Mascagni",
      img: teamPhotos.mario,
      bio: t("home.bios.mario"),
      link: "https://www.linkedin.com/in/mario-luiz-mascagni-oceanography-brazil/",
      group: groupsData.ufsc,
      role: t("home.members.roles.bolsista"),
    },
  };

  const authors = [
    authorsData.anita,
    authorsData.klein,
    authorsData.dennis,
    authorsData.luispedro,

    authorsData.anapaula,
    authorsData.elirio,
    authorsData.guilherme,
    authorsData.joao,
    authorsData.ligia,
    authorsData.paula,
    authorsData.pedrosouza,
    authorsData.wagner,

    authorsData.andrigo,
    authorsData.anderson,
    authorsData.bruna,
    authorsData.cicero,
    authorsData.eduardo,
    authorsData.henrique,
    authorsData.lais,
    authorsData.larissa,
    authorsData.luisafoppa,
    authorsData.luizafiorini,
    authorsData.mario,
  ];

  // create an array with published papers
  const papers = [
    {
      kind: t("home.papers.paper_text"),
      title:
        "Coastal Analyst System from Space Imagery Engine (CASSIE): Shoreline management module",
      event: "Environmental Modelling & Software 2021",
      authors: [authorsData.luispedro, authorsData.dennis, authorsData.klein],
      link: "https://www.sciencedirect.com/science/article/abs/pii/S1364815221000761",
    },
  ];

  // dispatch Authentication action with useEffect
  useEffect(() => {
    dispatch(AuthActions.loadClientAuth());
  }, []);

  // create devAdvOpen state
  const [devAdvOpen, setDevAdvOpen] = React.useState(true);

  // create cookiesAdvOpen state
  const [cookiesAdvOpen, setCookiesAdvOpen] = useLocalStorage(
    "showNewCookiesADV",
    true
  );

  // function to handle devAdvClose event (from devAdvOpen) deppendin on the reason
  const handleDevAdvClose = (reason) => {
    // if the reason isn't "clickaway" we close the devAdv
    if (reason !== "clickaway") {
      setDevAdvOpen(false);
    }
  };

  // function to handle cookiesAccept event (from cookiesAdvOpen) deppendin on the reason
  const handleCookiesAccept = (reason) => {
    // if the reason isn't "clickaway" we close the cookiesAdv and post the cookiesAccept event to the API
    if (reason !== "clickaway") {
      setCookiesAdvOpen(false);
      // postAcceptingToAPI();
    }
  };

  // function that send a POST request to the API to accept cookies
  const postAcceptingToAPI = () => {
    fetch("https://cassie-api.vercel.app/api/cookies", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        read: true,
      }),
    })
      .then((response) => {
        // if we get a bad response we show the error
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
      })
      .catch((error) => console.error("Error: ", error));
  };

  return (
    <HomePageLayout>
      <Box className={classes.heading}>
        <Container
          className={classes.headingContainer}
          maxWidth="md"
          display="flex"
          flexdirection="column"
        >
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <WhiteTextTypography className={classes.title} variant="h2">
                {t("self.fullTitle")}
              </WhiteTextTypography>
            </Grid>

            <Grid item xs={12} md={8}>
              <WhiteTextTypography className={classes.subtitle} variant="body1">
                {t("self.shortDesc")}
              </WhiteTextTypography>
            </Grid>

            <Grid item xs={12}>
              <Button
                variant="contained"
                className={classes.spaced_btn}
                style={{ marginTop: "10px" }}
                color="primary"
                size="large"
                href="https://earthengine.google.com/signup/"
                m="10"
              >
                <Avatar
                  className={classes.google}
                  variant="square"
                  alt="Google Logo"
                  src={geeLogo}
                />
                {t("home.instructions.btnEngineSingUp")}
              </Button>
              
              <Button
                disabled={busy}
                variant="contained"
                style={{ marginTop: "10px" }}
                size="large"
                color="primary"
                className={classes.spaced_btn}
                onClick={() =>
                  dispatch(
                    AuthActions.begin(() =>
                      dispatch(push("/main/selection"))
                    )
                  )
                }
              >
                <Avatar
                  className={classes.google}
                  variant="square"
                  alt="Google Logo"
                  src={busy ? googleLogoDisabled : googleLogo}
                />
                {t("auth.signin")}
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box className={classes.content} bgcolor="white">
        <Container maxWidth="md" display="flex" flexdirection="column">
          <Typography className={classes.title} variant="h3" align="center">
            {t("home.instructions.title")}
          </Typography>
          <Grid container p={5} justifyContent="center" alignItems="center">
            <Grid item xs={12}>
              <Typography
                variant="body1"
                className={classes.spaced_text}
                align="center"
              >
                {t("home.instructions.text")}
              </Typography>
            </Grid>
          </Grid>
          <Box display="flex" alignItems="center" justifyContent="center">
            <Button
              variant="outlined"
              className={classes.spaced_btn}
              color="primary"
              href="https://earthengine.google.com/signup/"
              m="10"
            >
              {t("home.instructions.btnEngineSingUp")}
            </Button>
            <Button
              variant="outlined"
              className={classes.spaced_btn}
              color="secondary"
              href={t("home.instructions.linkManual")}
            >
              {t("home.instructions.btnManual")}
            </Button>
            <Button
              variant="outlined"
              className={classes.spaced_btn}
              color="default"
              href={t("home.instructions.linkVideo")}
            >
              {t("home.instructions.btnVideo")}
            </Button>
          </Box>
        </Container>
      </Box>

      <Box className={classes.content}>
        <Container maxWidth="lg">
          <Typography
            className={classes.title}
            variant="h3"
            align="center"
            gutterBottom
          >
            {t("home.about.title")}
          </Typography>

          <Grid container spacing={4} justifyContent="center">
            <Grid item xs={12} md={4}>
              <Card>
                <CardMedia
                  component="img"
                  height="220"
                  image={CassieProjeto}
                  alt="Site do Projeto"
                />
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    {t("home.cards.projectSite.title")}
                  </Typography>
                  <Typography variant="body2">
                    {t("home.cards.projectSite.description")}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    href="https://cassiecore.paginas.ufsc.br/"
                    target="_blank"
                  >
                    {t("home.cards.projectSite.button")}
                  </Button>
                </CardActions>
              </Card>
            </Grid>

            <Grid item xs={12} md={4}>
              <Card>
                <CardMedia
                  component="img"
                  height="220"
                  image={CassiePesquisa}
                  alt="Pesquisa de Satisfação"
                />
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    {t("home.cards.survey.title")}
                  </Typography>
                  <Typography variant="body2">
                    {t("home.cards.survey.description")}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    href="https://forms.gle/KEDtMD9Bcvorgcm89"
                    target="_blank"
                  >
                    {t("home.cards.survey.button")}
                  </Button>
                </CardActions>
              </Card>
            </Grid>

            <Grid item xs={12} md={4}>
              <Card>
                <CardMedia
                  component="img"
                  height="220"
                  image={CassieFerramenta}
                  alt="Ferramenta CASSIE"
                />
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    {t("home.cards.tool.title")}
                  </Typography>
                  <Typography variant="body2">
                    {t("home.cards.tool.description")}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    href="https://cassiengine.org/"
                    target="_blank"
                  >
                    {t("home.cards.tool.button")}
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box mt={4} display="flex" justifyContent="center">
        <img
          src={charLanguage ? TimeLinePT : TimeLineEN}
          alt="Timeline"
          style={{
            width: "100%",
            maxWidth: "1200px",
            borderRadius: "8px",
          }}
        />
      </Box>

      <Box className={classes.content} bgcolor="white">
        <Container maxWidth="md" display="flex" flexdirection="column">
          <Typography className={classes.title} variant="h3" align="center">
            {t("home.members.title")}
          </Typography>

          <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12} md={4}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                href="https://share.google/uhKCdFT2eOGS8W7uz"
                target="_blank"
                rel="noopener"
              >
                {t("home.members.links.teamDescription")}
              </Button>
            </Grid>

            <Grid item xs={12} md={4}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                href="https://share.google/lWMyZoaus8wMqwPWJ"
                target="_blank"
                rel="noopener"
              >
                {t("home.members.links.currentTeam")}
              </Button>
            </Grid>

            <Grid item xs={12} md={4}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                href="https://share.google/jRUyMdi3h1cjXNWww"
                target="_blank"
                rel="noopener"
              >
                {t("home.members.links.teamHistory")}
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box className={classes.content}>
        <Container maxWidth="md" display="flex" flexdirection="column">
          <Grid container spacing={9} justifyContent="center">

            <Grid item xs={12} md={6} align="center">
              <Typography className={classes.title} variant="h4">
                {t("home.sponsor.realiza")}
              </Typography>

              <Grid container spacing={3} justifyContent="center">
                <Grid item xs={12} md={4} align="center">
                  <Link href={groupsData.loc.link} target="_blank" rel="noopener">
                    <img
                      src={"/grupos/" + groupsData.loc.img}
                      alt={groupsData.loc.name}
                      className={classes.sponsor_img}
                      style={{ height: "120px", marginTop: "-35px" }}
                    />
                  </Link>
                </Grid>

                <Grid item xs={12} md={4} align="center">
                  <Link href={groupsData.lia.link} target="_blank" rel="noopener">
                    <img
                      src={"/grupos/" + groupsData.lia.img}
                      alt={groupsData.lia.name}
                      className={classes.sponsor_img}
                    />
                  </Link>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={6} align="center">
              <Typography className={classes.title} variant="h4">
                {t("home.sponsor.apoio")}
              </Typography>

              <Grid container spacing={3} justifyContent="center">
                <Grid item xs={12} md={6} align="center">
                  <Link href={groupsData.cnpq.link} target="_blank" rel="noopener">
                    <img
                      src={"/grupos/" + groupsData.cnpq.img}
                      alt={groupsData.cnpq.name}
                      className={classes.sponsor_img}
                    />
                  </Link>
                  <Typography className={classes.spaced_text} variant="body1">
                    {t("home.sponsor.apoio_desc")}
                  </Typography>
                </Grid>

              </Grid>
            </Grid>

            <Grid item xs={12} align="center">
              <Typography className={classes.title} variant="h4">
                {t("home.sponsor.previousSections.institutionalCurrent")}
              </Typography>

              <Grid container spacing={3} justifyContent="center">
                <Grid item xs={12} md={3} align="center">
                  <Link href={groupsData.univali.link} target="_blank" rel="noopener">
                    <img
                      src={"/grupos/" + groupsData.univali.img}
                      alt={groupsData.univali.name}
                      className={classes.sponsor_img_partner}
                    />
                  </Link>
                </Grid>

                <Grid item xs={12} md={3} align="center">
                  <Link href={groupsData.ufsc.link} target="_blank" rel="noopener">
                    <img
                      src={"/grupos/" + groupsData.ufsc.img}
                      alt={groupsData.ufsc.name}
                      className={classes.sponsor_img_partner}
                    />
                  </Link>
                </Grid>

                <Grid item xs={12} md={3} align="center">
                  <Link href={groupsData.ufrgs.link} target="_blank" rel="noopener">
                    <img
                      src={"/grupos/" + groupsData.ufrgs.img}
                      alt={groupsData.ufrgs.name}
                      className={classes.sponsor_img_partner}
                    />
                  </Link>
                </Grid>
                <Grid item xs={12} md={3} align="center">
                  <Link href={groupsData.ulisboa.link} target="_blank" rel="noopener">
                    <img
                      src={"/grupos/" + groupsData.ulisboa.img}
                      alt={groupsData.ulisboa.name}
                      className={classes.sponsor_img_partner}
                    />
                  </Link>
                </Grid>

                <Grid item xs={12} md={3} align="center">
                  <Link href={groupsData.palmsoft.link} target="_blank" rel="noopener">
                    <img
                      src={"/grupos/" + groupsData.palmsoft.img}
                      alt={groupsData.palmsoft.name}
                      className={classes.sponsor_img_partner}
                    />
                  </Link>
                </Grid>

                <Grid item xs={12} md={3} align="center">
                  <Link href={groupsData.griffith.link} target="_blank" rel="noopener">
                    <img
                      src={"/grupos/" + groupsData.griffith.img}
                      alt={groupsData.griffith.name}
                      className={classes.sponsor_img_partner}
                    />
                  </Link>
                </Grid>

                <Grid item xs={12} md={3} align="center">
                  <Link href={groupsData.ufma.link} target="_blank" rel="noopener">
                    <img
                      src={"/grupos/" + groupsData.ufma.img}
                      alt={groupsData.ufma.name}
                      className={classes.sponsor_img_partner}
                    />
                  </Link>
                </Grid>

                <Grid item xs={12} md={3} align="center">
                  <img
                    src={"/grupos/" + groupsData.ima.img}
                    alt={groupsData.ima.name}
                    className={classes.sponsor_img_partner}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} align="center">
              <Grid container spacing={3} justifyContent="center" />
            </Grid>

            <Grid item xs={12} align="center">
              <Grid container spacing={3} justifyContent="center" />
            </Grid>


            <Grid item xs={12} align="center">
              <Typography className={classes.title} variant="h4">
                {t("home.sponsor.previousSections.closedPartnerships")}
              </Typography>

              <Grid container spacing={3} justifyContent="center">
                <Grid item xs={12} md={3} align="center">
                  <Link href={groupsData.atlantic.link} target="_blank" rel="noopener">
                    <img
                      src={"/grupos/" + groupsData.atlantic.img}
                      alt={groupsData.atlantic.name}
                      className={classes.sponsor_img_partner}
                    />
                  </Link>
                </Grid>

                <Grid item xs={12} md={3} align="center">
                  <Link href={groupsData.appix.link} target="_blank" rel="noopener">
                    <img
                      src={"/grupos/" + groupsData.appix.img}
                      alt={groupsData.appix.name}
                      className={classes.sponsor_img_partner}
                    />
                  </Link>
                </Grid>

                <Grid item xs={12} md={3} align="center">
                  <img
                    src={"/grupos/" + groupsData.boticario.img}
                    alt={groupsData.boticario.name}
                    className={classes.sponsor_img_partner}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} align="center">
              <Grid container spacing={3} justifyContent="center" />
            </Grid>

            <Grid item xs={12} align="center">
              <Grid container spacing={3} justifyContent="center" />
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        className={classes.snack}
        open={devAdvOpen}
        autoHideDuration={3000}
        style={{ display: "none" }}
        onClose={handleDevAdvClose}
        TransitionComponent={TransitionLeft}
      >
        <Alert
          elevation={5}
          variant="filled"
          onClose={handleDevAdvClose}
          severity="warning"
        >
          {t("home.warning.text")}{" "}
          <Link color="textPrimary" href="/problems">
            {t("home.warning.link")}
          </Link>
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        className={classes.snack}
        open={cookiesAdvOpen}
        onClose={handleCookiesAccept}
        message={t("home.cookies.text")}
        action={
          <React.Fragment>
            <Button color="secondary" size="small" onClick={handleCookiesAccept}>
              {t("home.cookies.link")}
            </Button>
          </React.Fragment>
        }
      ></Snackbar>
    </HomePageLayout>
  );
}

export default HomePage;